import Sortable from 'sortablejs';

function configReordenar() {
	var elementos = document.querySelectorAll('.js-sortable');

	if(elementos.length > 0) {
		Array.from(elementos).forEach(elemento => {
			Sortable.create(elemento, {
				animation: 150,
				ghostClass: 'imagem-ghost',
				dataIdAttr: 'data-id',
				handle: '.imagem__handle',
				filter: '.imagem--no-drag',
				store:
				{
					/**
					 * Save the order of elements. Called onEnd (when the item is dropped).
					 * @param {Sortable}  sortable
					 */
					set: function (sortable) {
						var funcao = sortable.el.getAttribute('data-funcao');
						if(!funcao) {
							funcao = 'reordenar_ajax';
						}

						var ordem = sortable.toArray().join('&');
						var secao = document.querySelector('#secao_cod').value;
						var obj = document.querySelector('#obj_id').value;
						var tipo = document.querySelector('#obj_tipo').value;

						$.post(
							baseurl+'admin/'+secao+'/'+funcao,
							{
								'ordem': ordem,
								'obj': obj,
								'tipo': tipo
							},
							function() {
								var $resposta = $('.mensagem-resposta');
								$resposta.html('Ordem atualizada.').fadeIn('slow');
								setTimeout (function() { $resposta.fadeOut(); }, 2000);
							}
						);
					}
				}
			});
		});
	}
}

export default configReordenar
